import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';
import Select from '../../commonComponents/util/Select';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import CreateCampaignListModal from '../campaignsCommon/CreateCampaignListModal';
import WarningModal from '../../commonComponents/shared/WarningModal';
import { CampaignListTypes } from '../../../lib/systemVariables';
import { formatCurrency, stripCurrencyFormat } from '../../../lib/utils';

const initialState = {
    campaignList: {},
    emailMessage: '',
    defaultAmount: '',
    submitAttempted: false,
    checkAddListRule: true,
    promptReceivedPast60days: false,
    promptDuplicateApplications : false,
    showModals: {
        createCampaignListModal: false,
        campaign60DayRuleAlertModal: false,
        duplicateApplicationsAlertModal: false,
    }
};

export default class AddCampaignListModal extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = initialState;
    }

    onClose() {
        this.props.close();
        this.setState(initialState);
    }

    onSelectList(name, value) {
        const campaignList = this.props.campaignLists.data
            .filter(list => list.campaignListId.toString() === value.toString())[0];
        if (campaignList) {
            this.setState({ campaignList });
        }
    }

    onChange(name, value) {
        this.setState({ [name]: value });
    }

    async onSubmit() {
        this.setState({ submitAttempted: true, error: false });

        if (!this.state.campaignList.campaignListId
            || (this.state.campaignList.campaignListType === CampaignListTypes.Internal
                && (this.state.defaultAmount > (this.props.campaign.isIsraeli ? this.props.campaign.maxAmountShekel : this.props.campaign.maxAmountDollar))))
            return;

        await this.props.addList(this.state.campaignList.campaignListId, this.state.emailMessage, this.state.defaultAmount, !this.state.checkAddListRule);

        if (this.props.success) {
            this.onClose();
        } else {
            if (this.state.checkAddListRule && this.props.message &&
                (this.props.message.indexOf("60 days") >= 0 || this.props.message.indexOf("another application") >= 0) ){
                    const promptDuplicateApplications = this.props.message.indexOf("another application") >= 0;
                    const promptReceivedPast60days = !promptDuplicateApplications || this.props.message.indexOf("|") >= 0;
    
                    this.setState({ promptReceivedPast60days, promptDuplicateApplications },
                        this.toggleModal.bind(this, promptReceivedPast60days ? 'campaign60DayRuleAlertModal' : 'duplicateApplicationsAlertModal'));
            } else {
                this.setState({ error: true });
            }
        }
    }

    async createCampaignList(list) {
        await this.props.createList(list);
        if (this.props.creatingList.success) {
            await this.props.getCampaignLists();
            this.onSelectList('campaignListId', this.props.creatingList.campaignListId);
        }
    }

    render() {
        return (
            <div>
                <Modal modalShowing={this.props.show && !this.state.showModals.createCampaignListModal}>
                    <div className="modal-container">
                        <div className="modal add-list-modal large-modal">
                            <div className="modal-header">
                                <h4 className="page-header">Add List</h4>
                                <i className="icon ion-ios-close-empty" onClick={this.onClose.bind(this)}></i>
                            </div>
                            <div className="modal-section choose-list-container">
                                {!this.props.campaignLists.loading && (this.props.campaignLists.data.length > 0
                                    ? <div className="custom-select">
                                        <ValidatedInput input={<Select
                                            options={this.props.campaignLists.data}
                                            loading={this.props.campaignLists.loading} />}
                                            label="Choose List" name="campaignList" value={this.state.campaignList.campaignListId}
                                            onChange={this.onSelectList.bind(this)}
                                            required={true} showRequiredError={this.state.submitAttempted} />
                                    </div>
                                    : <p className="empty-state text-center">
                                        <i className="material-icons">not_interested</i>
                                        There are no {this.props.hasLists ? 'more ' : ''}campaign lists that match the campaign location group.  <br /> Click below to create a new list.
                                      </p>
                                )}
                                {this.state.campaignList.campaignListId > 0 &&
                                    (this.state.campaignList.campaignListType === CampaignListTypes.External ? <div className="add-list-margin-top">
                                        <label className="input-label">Add Message</label>
                                        <textarea name="emailMessage" value={this.state.emailMessage} onChange={e => this.onChange(e.target.name, e.target.value)} />
                                        <p className="small-text info-text">
                                            <i className="icon-info icon-left middle"></i>
                                            List will be sent to {this.state.campaignList.managerName && `${this.state.campaignList.managerName} at `}
                                            {this.state.campaignList.managerEmail} for review and update.
                                    </p>
                                    </div> : <div className="add-list-margin-top">
                                            <ValidatedInput input={<CurrencyFormatInput isIsraeli={this.props.campaign.isIsraeli} />}
                                                label="Default Amount" name="defaultAmount" value={this.state.defaultAmount}
                                                onChange={this.onChange.bind(this)}
                                                validated={true} showValidationError={true}
                                                validate={val => !val || stripCurrencyFormat(val) <=
                                                    (this.props.campaign.isIsraeli ? this.props.campaign.maxAmountShekel : this.props.campaign.maxAmountDollar)}
                                                errorMessage={`Default amount cannot exceed ${formatCurrency(this.props.campaign.isIsraeli ? this.props.campaign.maxAmountShekel : this.props.campaign.maxAmountDollar, this.props.campaign.isIsraeli)}`} />
                                        </div>
                                    )}
                            </div>
                            <div className="modal-footer flex-justify">
                                <button className="btn btn-accent2" onClick={this.toggleModal.bind(this, "createCampaignListModal")}>Create List</button>
                                {this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                                    <div className="modal-btns text-right no-wrap-error">
                                        <button className="btn btn-accent" onClick={this.onClose.bind(this)}>Cancel</button>
                                        <button className="btn btn-primary" disabled={!this.state.campaignList.campaignListId}
                                            onClick={this.onSubmit.bind(this)}>
                                            {this.state.campaignList.campaignListType === CampaignListTypes.External ? "Send" : "Add"}</button>
                                        <FadeOutErrorMessage show={this.state.error} message={this.props.message} />
                                    </div>}
                            </div>
                        </div>
                    </div>
                </Modal>

                <CreateCampaignListModal
                    show={this.state.showModals.createCampaignListModal}
                    close={this.toggleModal.bind(this, "createCampaignListModal")}
                    {...this.props.creatingList}
                    isAdmin={this.props.isAdmin}
                    loading={this.props.creatingList.loading || this.props.campaignLists.loading}
                    locationId={this.props.campaign.locationId}
                    locations={this.props.locations}
                    individualCategories={this.props.individualCategories}
                    organizationCategories={this.props.organizationCategories}
                    organizations={this.props.organizations}
                    ILFunds={this.props.ILFunds}
                    USFunds={this.props.USFunds}
                    createCampaignList={this.createCampaignList.bind(this)} />

                <WarningModal
                    show={this.state.showModals.campaign60DayRuleAlertModal}
                    close={this.toggleModal.bind(this, "campaign60DayRuleAlertModal")}
                    message={(this.props.message || "").split('|')[0]}
                    continue={() => {
                        this.setState({ checkAddListRule: false }, 
                            this.state.promptDuplicateApplications ? this.toggleModal.bind(this, 'duplicateApplicationsAlertModal') : this.onSubmit);
                    }}
                    cancel={() => {
                        this.setState({ checkAddListRule: true });
                    }} />

                 <WarningModal
                    show={this.state.showModals.duplicateApplicationsAlertModal}
                    close={this.toggleModal.bind(this, "duplicateApplicationsAlertModal")}
                    message={(this.props.message || "").split('|')[(this.props.message || "").split('|').length - 1]}
                    continue={() => {
                        this.setState({ checkAddListRule: false }, this.onSubmit);
                    }}
                    cancel={() => {
                        this.setState({ checkAddListRule: true });
                    }} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/AddCampaignListModal.jsx